'use strict';

angular.module('userRequestEditControllers')

.controller('UserRequestGettingStartedController', ['$scope', '$state', 'sameAsEmployee', 'userRequest', 'systemTypes', function ($scope, $state, sameAsEmployee, userRequest, systemTypes) {

    // When request is in process activity, then redirect to Events
    if (userRequest.IsInProcessActivity) {
        $state.go('userAccessRequest.edit.events', {
            userAccessRequestId: $scope.userRequest.UserAccessRequestID
        });
        return;
    }
}]);